import { useEffect, useRef } from 'react';
import { useLogGoodsAnalyticsEvent } from '../../../../../hooks/useLogGoodsAnalyticsEvent';

/**
 * 사이즈 탭 노출 로깅(`DISPLAY_SIZE_TAB`).
 *
 * **웹 전용**이다 — 네이티브 `SizeTab` 은 사이즈 탭을 웹뷰(`GoodsWebviewContent`)로 띄우고
 * 그 콘텐츠(ably-webview-react `pages/goods/_component/GoodsDetail/ProductInformation/ProductInfo`)
 * 가 직접 이 이벤트를 쏜다. 웹은 같은 화면을 RN 컴포넌트로 직접 그려서 이벤트가 비어 있었다.
 * 그래서 `SizeTab.web.tsx` 에서만 호출한다(네이티브에서 부르면 중복 발화).
 *
 * 참조: ably-webview-react `pages/goods/[sno]/size/_hooks/useLogGoodsSize.ts` 의 `logDisplaySizeTab`.
 * 파라미터는 `useLogGoodsAnalyticsEvent` 가 주입하는 기본값만 쓴다.
 */
export const useLogDisplaySizeTab = ({ focused }: { focused: boolean }) => {
  const logGoodsAnalytics = useLogGoodsAnalyticsEvent();
  const loggedRef = useRef(false);

  useEffect(() => {
    if (!focused || loggedRef.current) return;

    const logged = logGoodsAnalytics({ name: 'DISPLAY_SIZE_TAB' });

    // PDP 기본 데이터(goodsBasic/goodsDetail)가 아직 없으면 false 를 반환한다.
    // 그 경우 로깅을 완료로 표시하지 않고 다음 렌더에 다시 시도한다.
    if (logged) {
      loggedRef.current = true;
    }
  }, [focused, logGoodsAnalytics]);
};
